'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/modal.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _selectors = require('../selectors');
var selectors = _interopRequireWildcard(_selectors);
var _actions = require('../actions');
var _reactRouter = require('react-router');
var _propTypes2 = require('@marmalade/prop-types');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);
  function Modal() {
    _classCallCheck(this, Modal);
    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }
  _createClass(Modal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.activeModal.length && this.props.location.pathname !== nextProps.location.pathname) {
        this.props.hideModal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var Component = '';
      this.props.content.forEach(function (obj) {
        if (obj.id === _this2.props.activeModal) {
          Component = obj.Component;
        }
      });
      return Component ? _react2.default.createElement(Component, {
        data: this.props.openModalData,
        zIndex: 999999999,
        position: 'fixed',
        left: 0,
        right: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        },
        __self: this
      }) : null;
    }
  }]);
  return Modal;
}(_react2.default.Component);
Modal.propTypes = {
  content: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    Component: _propTypes.func.isRequired,
    id: _propTypes.string.isRequired
  })).isRequired,
  activeModal: _propTypes.string.isRequired,
  openModalData: _propTypes.any,
  hideModal: _propTypes.func.isRequired,
  location: _propTypes2.location
};
Modal.defaultProps = {
  openModalData: undefined
};
exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    activeModal: selectors.modalComponent(state),
    openModalData: selectors.openModalData(state)
  };
}, {
  hideModal: _actions.hideModal
})(Modal));